import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { isOwner } from "@/lib/roles";

export default function ProtectedRoute({ children, adminOnly = false, fieldAgentHome = false }) {
  const { user, checking } = useAuth();
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#EEF2F8] text-[#15233B]">
        <div className="text-sm tracking-[0.2em] uppercase font-semibold opacity-70">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !isOwner(user)) return <Navigate to="/" replace />;
  // Field agents are only allowed at /field — redirect them from any other route
  if (user.role === "field_agent" && !fieldAgentHome) return <Navigate to="/field" replace />;
  return children;
}
